import { createStore } from 'vuex'
import auth from './modules/auth'
import geolocation from './modules/geolocation'
import phoneRecording from './modules/phoneRecording'
import other from './modules/other'
const modules = { auth, geolocation, phoneRecording, other }
const store = createStore({
    modules,
    // Enable strict mode in development to get a warning
    // when mutating state outside of a mutation.
    // https://vuex.vuejs.org/guide/strict.html
    strict: !import.meta.env.PROD,
})

export default store
